import { ref } from 'vue'

import { usePortalStore } from '@/stores/portal.store'

export const clearRemovedRoundingRowFlag = (document, removedRow) => {
  if (!document || !removedRow) return
  if (removedRow.is_rounding_row) { document.has_rounding_row = false }
  if (removedRow.is_rounding_expense_row) { document.has_rounding_expense_row = false }
}

export const useRoundingRow = ({ gridRef, refreshGridAsync, onSaved, readOnly, data } = {}) => {
  const portalStore = usePortalStore()

  const showRoundingRowPopup = ref(false)
  const roundingRowType = ref(null)
  const roundingRowReadOnly = ref(false)
  const roundingRowData = ref(null)

  const addExpenseRow = (isRoundingRow = true) => {
    roundingRowReadOnly.value = false
    roundingRowData.value = null
    roundingRowType.value = isRoundingRow ? portalStore.roundingRowType.ROUNDING : portalStore.roundingRowType.EXPENSE_PERCENTAGE
    showRoundingRowPopup.value = true
  }

  const viewRoundingRow = (row) => {
    roundingRowData.value = row
    roundingRowReadOnly.value = true
    roundingRowType.value = row?.is_rounding_expense_row ? portalStore.roundingRowType.EXPENSE_PERCENTAGE : portalStore.roundingRowType.ROUNDING
    showRoundingRowPopup.value = true
  }

  const closeRoundingRow = () => {
    showRoundingRowPopup.value = false
    roundingRowReadOnly.value = false
    roundingRowData.value = null
  }

  const repaintAllRows = () => {
    const grid = gridRef?.value?.instance
    grid?.repaintRows(grid.getVisibleRows().map(row => row.rowIndex))
  }

  const onRoundingRowSaved = async() => {
    closeRoundingRow()
    onSaved?.()
    await refreshGridAsync?.()
    repaintAllRows()
  }

  const bindViewRoundingButton = (rowButtons) => {
    const viewButton = rowButtons.find(button => button.name === 'view')
    if (!viewButton) return

    const defaultViewClick = viewButton.onClick
    viewButton.onClick = async(args) => {
      const row = args.grid?.instance?.getVisibleRows().find(visibleRow => visibleRow.key === args.entityId)?.data
      if (row?.is_rounding_row || row?.is_rounding_expense_row) {
        viewRoundingRow(row)
      } else {
        await defaultViewClick(args)
      }
    }
  }

  return {
    showRoundingRowPopup,
    roundingRowType,
    roundingRowReadOnly,
    roundingRowData,
    addExpenseRow,
    viewRoundingRow,
    closeRoundingRow,
    repaintAllRows,
    onRoundingRowSaved,
    bindViewRoundingButton,
  }
}
